module.exports = __webpack_public_path__ + "static/media/blog.599ae7b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/blog.png
// module id = 283
// module chunks = 0